import * as React from "react"

const ActiveCheckbox = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <rect width={24} height={24} fill="#008761" rx={4.8} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m18.402 7.201-8.8 8.8-4-4"
    />
  </svg>
)
export default ActiveCheckbox
